import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import * as Sentry from '@sentry/react';
import { t } from 'i18next';
import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import { HEADER_HEIGHT } from '../Dispatch/components/drivers/constants';

export const InternalErrorPage = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        height: `calc(50vh - ${HEADER_HEIGHT}px)`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      <Grid
        container
        sx={{
          width: '100%',
          maxWidth: '500px',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Typography variant="h3">🚧</Typography>
        <Typography variant="h4">
          {t('error_pages.internal_server_error.title')}
        </Typography>
        <Typography variant="subtitle1">
          {t('error_pages.internal_server_error.description')}
        </Typography>
        <>
          <Typography sx={{ fontWeight: 600 }}>
            {t('error_pages.internal_server_error.troubleshooting_subtitle')}
          </Typography>
          <List sx={{ listStyleType: 'disc', pl: 3, pt: 0 }}>
            <ListItemText sx={{ display: 'list-item', pt: 0, mt: 0 }}>
              <Typography variant="subtitle1">
                {t('error_pages.internal_server_error.troubleshooting_item_1')}
              </Typography>
            </ListItemText>
            <ListItemText sx={{ display: 'list-item' }}>
              <Typography variant="subtitle1">
                <Link href="https://status.tread.io" color={theme.palette.info.main}>
                  {t('error_pages.internal_server_error.troubleshooting_item_2')}
                </Link>
              </Typography>
            </ListItemText>
          </List>
        </>
      </Grid>
    </Box>
  );
};

// react-router's route-level errorElement catches render errors before they can
// reach the outer Sentry.ErrorBoundary in main.tsx. This wrapper captures them.
export const RouteErrorElement = () => {
  const error = useRouteError();

  useEffect(() => {
    if (error && !isRouteErrorResponse(error)) {
      Sentry.captureException(error);
    }
  }, [error]);

  return <InternalErrorPage />;
};
